import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { blogArticles } from "@/pages/BlogPost";

export default function LandingBlog() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <div className="flex items-center justify-center gap-2 mb-2">
        <BookOpen className="h-5 w-5 text-primary" />
        <h2 className="text-2xl font-bold text-foreground text-center">
          Blog & Artigos
        </h2>
      </div>
      <p className="text-muted-foreground text-center text-sm mb-8">
        Conteúdo educativo sobre dependência química, recuperação e saúde mental
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {blogArticles.map((a) => (
          <Link key={a.slug} to={`/blog/${a.slug}`} className="group">
            <Card className="border-border/50 bg-card/80 hover:shadow-md hover:-translate-y-1 transition-all duration-300 h-full">
              <CardContent className="p-5 flex flex-col gap-3 h-full">
                <span className="text-[10px] font-semibold uppercase tracking-wider text-primary-foreground bg-primary self-start px-2 py-0.5 rounded-full">
                  {a.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground leading-snug">
                  {a.title}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed flex-1">
                  {a.summary}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary group-hover:underline mt-auto">
                  Leia mais <ArrowRight className="h-3 w-3" />
                </span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
}
